export const BANNER_PLACEHOLDER = '/assets/images/placeholder/placeholder-banner.svg';
export const DEGRADE_CONFIG_DIRECTION = '90deg';
